import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse, HttpUtilService } from "../http-util.service";
import { PriceListTemplate } from "src/app/models/sales/price-list-template";

@Injectable({
  providedIn: "root",
})
export class PriceListTemplateService {
  private readonly baseUrl = "PriceListService.asmx";

  constructor(private http: HttpUtilService) {}

  getAllPriceListTemplates(): Observable<HttpResponse<PriceListTemplate[]>> {
    return this.http.get(`${this.baseUrl}/GetAllPriceListTemplate`);
  }

  getAllPriceListTemplateDetails(
    id: string,
  ): Observable<HttpResponse<PriceListTemplate>> {
    return this.http.get(`${this.baseUrl}/GetAllPriceListTemplateDetails`, {
      params: { id },
    });
  }

  updatePriceListTemplate(
    model: PriceListTemplate,
  ): Observable<HttpResponse<PriceListTemplate>> {
    return this.http.post(`${this.baseUrl}/UpdatePriceListTemplate`, { model });
  }

  addPriceListTemplate(
    model: Omit<PriceListTemplate, "ID">,
  ): Observable<HttpResponse<PriceListTemplate>> {
    return this.http.post(`${this.baseUrl}/AddPriceListTemplate`, { model });
  }

  deletePriceListTemplates(
    ids: Pick<PriceListTemplate, "ID">[],
  ): Observable<HttpResponse<unknown>> {
    return this.http.post(`${this.baseUrl}/DeletePriceListTemplates`, { ids });
  }

  deletePriceListTemplate(id: string): Observable<HttpResponse<unknown>> {
    return this.http.post(`${this.baseUrl}/DeletePriceListTemplate`, { id });
  }
}
